import {React, observer} from '@api'
import {Icon, Spinner} from '@blueprintjs/core'
import {Tooltip2} from '@api'

import {Tooltip} from '@material-ui/core'
import {useGroupByGroupStore, useStores} from '@modules'

import {icons} from '@stores/ui'
import {PrimaryIconButton} from 'centric-ui-components'

export const GroupAggregateDetailsButton = observer<{ className?: string }>(({className}) => {
  const {strings, onToggleAggregateDetails, showingAggregateDetails, catalog} = useGroupByGroupStore()

  if (!catalog.catalogConfig?.features?.groupBy?.detailAggregations) {
    return null
  }

  return (
    <Tooltip2 content={strings.aggregateDetails}>
      <PrimaryIconButton
        data-name='aggregationDetails'
        wrapperClassName={className}
        icon={<Icon icon='grouped-bar-chart'/>}
        active={showingAggregateDetails}
        onClick={onToggleAggregateDetails}
      />
    </Tooltip2>
  )
})

export const InlineGroupAggregateToggleButton = observer<{ className?: string }>(function InlineGroupAggregateToggleButton({className}) {
  const groupByGroupStore = useGroupByGroupStore(),
    {strings, catalog} = useStores()

  //
  if (!groupByGroupStore || !catalog.canShowAggs) {
    return null
  }

  // Only show if global group aggregations is off
  if (catalog.settings.showAggs) return null

  return (
    <Tooltip2 content={strings.showInlineGroupAggregation}
              placement={groupByGroupStore?.isCard ? 'right' : 'bottom'}
    >
      <PrimaryIconButton
        data-name='GroupAggregateToggleButton'
        wrapperClassName={className}
        icon={icons.aggregateDetails}
        active={groupByGroupStore.showingInlineAggregationDetails}
        onClick={groupByGroupStore.toggleShowInlineAggregationDetails}
      />
    </Tooltip2>
  )
})

export const ToggleAggregationLocationButton = observer<{ className?: string }>(function ToggleAggregationLocationButton({className}) {
  const groupByGroupStore = useGroupByGroupStore(),
    {strings, catalog, catalog: {canShowAggs, aggregation}, flexLayout: {isMaximized}} = useStores()

  if (!aggregation || !canShowAggs) {
    return null
  }

  const {aggregateLocation, onToggleAggregateDetailsLocation} = aggregation,
    active = groupByGroupStore ? groupByGroupStore.showingAggregateDetailsinSidebar : aggregateLocation === 'sidebar',
    isInSidebar = aggregateLocation === 'sidebar'

  return (
    <PrimaryIconButton
      tooltip={strings.showAggregatesInSidebar}
      tooltipClassName={groupByGroupStore?.isCard ? 'right' : 'bottom'}
      data-name='groupSidebarAggregate'
      wrapperClassName={className}
      icon={isInSidebar ? 'add-column-left' : 'add-column-right'}
      active={active}
      onClick={isInSidebar || !groupByGroupStore ? onToggleAggregateDetailsLocation : groupByGroupStore.onToggleAggregateDetailsSidebar}
    />
  )
})

export const ShowGlobalAggregationsToggleButton = observer<{ className?: string }>(function ShowAggregationsToggleButton({className}) {
  const {catalog: {features, settings, aggregation: {onToggleShowAggs}, settings: {showAggs}}} = useStores()

  if (!features.groupBy?.detailAggregations) {
    return null
  }

  return (
    <PrimaryIconButton
      tooltip={'Show Aggregations'}
      tooltipPosition={'bottom'}
      wrapperClassName={className}
      icon={<Icon icon={icons.aggregateDetails}/>}
      active={showAggs}
      onClick={onToggleShowAggs}
    />
  )
})

/*
Taken from SidebarAggregateDetails when switched to use <ToggleAggregationLocationButton /> above
<Tooltip2 content={strings.showAggregatesInSidebar}>
              <PrimaryIconButton icon={<Icon icon='add-column-right'/>} active={catalog.settings.aggregateLocation != 'inline'} onClick={onToggleAggregateDetailsLocation}/>
            </Tooltip2>
 */



// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/GroupByCatalog_Groups/AggregateDetails/GroupAggregateDetailsButton.tsx